import { apiFetch } from "../utils/apiFetch";
import { API_BASE_CLIENT as API_BASE } from "../config/vars";
import { formatApiErrorDetail } from "../utils/clientRestrictionsUi";

// 🔹 Отримати список відгуків клієнта
export const getFeedbackList = async () => {
    try {
        const response = await apiFetch(`${API_BASE}/feedbacks/client`);

        const data = await response.json();

        if (!response.ok) throw new Error(formatApiErrorDetail(data.detail, "Unknown error"));
        return { success: true, data };
    } catch (error) {
        return { success: false, error: error.message || "Connection error" };
    }
};

// 🔹 Надіслати новий відгук
export const sendFeedback = async ({ message }) => {
    try {
        const response = await apiFetch(`${API_BASE}/feedbacks/client/`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                message,
            }),
        });

        const data = await response.json();

        if (!response.ok) throw new Error(formatApiErrorDetail(data.detail, "Unknown error"));
        return { success: true };
    } catch (error) {
        return { success: false, error: error.message || "Connection error" };
    }
};
